import React from 'react';
import { fireErrorAnalytics } from '@atlassian/error-handling';
import { ErrorBoundary } from 'react-error-boundary';
import { fg } from '@atlaskit/platform-feature-flags';
import { SelectedTemplatePreview } from './selected-template-preview';
import { type BlueprintData } from '../../../state/ui/blueprints/types';
import { type CreateEmbeddedPage } from './types';

type Props = {
	blueprints: BlueprintData[];
	contentId: string | null;
	isConfluenceActivationCompleteForPreselectedTemplate: boolean;
	createEmbeddedPage: CreateEmbeddedPage;
};

export const ShowUserPreselectedTemplateExperiment = ({
	contentId,
	isConfluenceActivationCompleteForPreselectedTemplate,
	blueprints,
	createEmbeddedPage,
}: Props) => {
	return (
		<ErrorBoundary
			FallbackComponent={() => <></>}
			onError={(error) => {
				fireErrorAnalytics({
					meta: {
						id: 'project-pages-embedded-confluence-error',
						packageName: '@atlassiansox/project-pages',
					},
					error: error as Error,
				});
			}}
		>
			{fg('project_pages_embededed_confluence_gate') && (
				<SelectedTemplatePreview
					contentId={contentId}
					isConfluenceActivationCompleteForPreselectedTemplate={
						isConfluenceActivationCompleteForPreselectedTemplate
					}
					blueprints={blueprints}
					createEmbeddedPage={createEmbeddedPage}
				/>
			)}
		</ErrorBoundary>
	);
};
